var exports = {
  "M": "CopyLinkSection.module__linkFooter___UnhMQ0",
  "e": "CopyLinkSection.module__linkSectionLabel___UnhMQ0",
};

module.exports = exports;
